import {
  GraphQLClient,
  ClientError,
  type TypedDocumentString,
} from 'graphql-request';
import { csrfHeaders } from './csrf';

const client = new GraphQLClient(window.location.origin + '/graphql', {
  credentials: 'include',
});

function redirectToSignInIfUnauthorized(error: unknown): void {
  if (
    error instanceof ClientError &&
    error.response?.status === 401 &&
    window.location.pathname !== '/signin'
  ) {
    const currentUrl = window.location.pathname + window.location.search;
    window.location.href = `/signin?redirect=${encodeURIComponent(currentUrl)}`;
  }
}

export function graphqlRequest<T, V>(
  document: TypedDocumentString<T, V>,
  variables?: object,
  signal?: AbortSignal
): Promise<T> {
  client.setHeaders(csrfHeaders());
  return client.request<T>({ document, variables, signal }).catch((error) => {
    redirectToSignInIfUnauthorized(error);
    throw error;
  });
}
